/**
 * Service: salesRules
 */
angular.module('acme.common.service.salesRules', [
  'acme.common.service.api'
])
.service('SalesRulesService', ['ApiService', function(ApiService) {

    return {

      limits: {},

      timeFrames: {
        day: {
          name: 'day',
          label: 'per day'
        },
        week: {
          name: 'week',
          label: 'per week'
        },
        month: {
          name: 'month',
          label: 'per month'
        },
        year: {
          name: 'year',
          label: 'per year'
        },
        event: {
          name: 'lifetime',
          label: 'per event'
        }
      },

      ruleTypes: [
        {
          label: 'Member',
          name: 'memberBenefits'
        },
        {
          label: 'Event',
          name: 'eventSales'
        }
      ],

      reasonTypes: [
        {
          label: 'Cart',
          name: 'Cart'
        },
        {
          label: 'Transaction',
          name: 'Transaction'
        }
      ],

      ticketsQuantity: {},

      init: function() {
        return true;
      },

      resetLimits: function() {
        this.limits = {};
      },

      hasSalesRules: function(event) {
        return (event &&
          event.hasOwnProperty('ruleSets') &&
          event.ruleSets.hasOwnProperty('associated') &&
          event.ruleSets.associated &&
          event.ruleSets.hasOwnProperty('ruleSetIds') &&
          event.ruleSets.ruleSetIds instanceof Array);
      },

      findTimeFrame: function(timeFrame) {
        var r = null;

        if (timeFrame) {
          switch(timeFrame.toLowerCase()) {
            case this.timeFrames.day.name:
              r = this.timeFrames.day;
              break;
            case this.timeFrames.week.name:
              r = this.timeFrames.week;
              break;
            case this.timeFrames.month.name:
              r = this.timeFrames.month;
              break;
            case this.timeFrames.year.name:
              r = this.timeFrames.year;
              break;
            case this.timeFrames.event.name:
              r = this.timeFrames.event;
              break;
          }
        }

        return r;
      },

      getTicketsForLimits: function(event) {
        var tickets = [],
          prices = this.getPrices(event);

        if (prices instanceof Array) {
          tickets = prices.map(function(price) {
            return {
              isRetail: price.isRetail,
              ticketTypeId: price.ticketingTypeId,
              name: price.ticketingTypeName,
              quantity: price.quantity
            };
          });
        }

        return tickets;
      },

      getPrices: function(event) {
        var r = [];
        if (event.tickets) {
          angular.forEach(event.tickets, function(ticket) {
            if (!ticket.isRetail) {
              r.push(ticket);
            }
          });
        }
        return r;
      },

      getGroupQuantity: function(event) {
        r = {};
        if (event.tickets) {
          angular.forEach(event.tickets, function(ticket) {
            if (!r.hasOwnProperty(ticket.ticketingTypeId)) {
              r[ticket.ticketingTypeId] = ticket.quantity;
            } else {
              r[ticket.ticketingTypeId] += ticket.quantity;
            }
          });
        }
        return r;
      },

      updateTicketLimits: function(event, sameDayEventTicketQuantities) {
        var self = this,
          tickets = self.getTicketsForLimits(event);

        self.ticketsQuantity = self.getTicketsQuantities(tickets);

        event.memberDiscountedPriceMap = {};
        event.memberTicketLimitMap = {};
        event.memberGroupLimitMap = {};
        event.ticketLimitGroups = {};

        event.memberTicketLimitMap = this.getMemberTicketLimit(tickets, event.eventId);
        event.memberGroupLimitMap = this.getMemberGroupLimit(tickets, event.eventId);

        self.computeGroupTicketLimits(event, sameDayEventTicketQuantities);

        event.hasLimits = (event.memberTicketLimitMap && event.memberTicketLimitMap.hasLimits) || (event.memberGroupLimitMap && event.memberGroupLimitMap.hasLimits);
        event.hasSalesRuleRestriction = (event.memberTicketLimitMap && event.memberTicketLimitMap.hasSalesRuleRestriction) || (event.memberGroupLimitMap && event.memberGroupLimitMap.hasSalesRuleRestriction);
        event.hasLimitErrors = self.eventHasLimitErrors(event, sameDayEventTicketQuantities, false);
        event.hasSalesRuleErrors = self.eventHasLimitErrors(event, sameDayEventTicketQuantities, true);

        event.noLimitViolations = !(event.hasLimits);
        event.noSalesRulesViolations = !(event.hasSalesRuleRestriction);

      },

      computeGroupTicketLimits: function(event, sameDayEventTicketQuantities) {
        var self = this,
          ticketTypeIds = [],
          groups;

        // reset all ticket type group limits
        this.setMemberTicketLimitGroups(event, event.ticketLimitGroups, null, false);
        this.setMemberTicketLimitGroups(event, event.ticketLimitGroups, null, true);

        if (event.memberGroupLimitMap.hasOwnProperty('regular')) {
          groups = event.memberGroupLimitMap.regular;
          //get quantities for prices in the limit
          angular.forEach(groups, function(group) {
            var groupQuantity = 0,
                preventGroupQuantity = 0;

            ticketTypeIds = group.groupId
                                 .split('-')
                                 .filter(function(item, index, arr) {
                                   return arr.indexOf(item) === index;
                                 });

            // a bit hacky, but if the rule type for this group is eventSales, then we need to use the retail ticket quantities not the regular ones tickets ENG-5046
            if (!group.ruleType || (group.ruleType.name === self.ruleTypes[0].name)) {
              groupQuantity = self.getQuantityForTicketTypes(event.tickets, ticketTypeIds, false, sameDayEventTicketQuantities);
            } else {
              // it's event sales, so we need to calculate quantities for both retail and regular
              groupQuantity = self.getQuantityForTicketTypes(event.tickets, ticketTypeIds, false, sameDayEventTicketQuantities, group);
              groupQuantity = groupQuantity + self.getQuantityForTicketTypes(event.tickets, ticketTypeIds, true, sameDayEventTicketQuantities, group);

              preventGroupQuantity = self.getQuantityForPreventTicketTypes(event.tickets, ticketTypeIds, false, sameDayEventTicketQuantities, group);
              preventGroupQuantity = preventGroupQuantity + self.getQuantityForPreventTicketTypes(event.tickets, ticketTypeIds, true, sameDayEventTicketQuantities, group);
            }

            angular.forEach(ticketTypeIds, function(ticketTypeId) {
              if (event.ticketLimitGroups[ticketTypeId]) {
                event.ticketLimitGroups[ticketTypeId]['regular'].groups.push({
                  groupMax: group.remaining,
                  groupQuantity: groupQuantity,
                  preventGroupQuantity: preventGroupQuantity,
                  groupId: group.groupId,
                  isPreventRule: group.isPreventRule,
                  inCartLimit: group.inCartLimit,
                  timeFrame: group.timeFrame,
                  ruleType: group.ruleType,
                  violation: group.violation
                });
              }
            });

          });
        }

        if (event.memberGroupLimitMap.hasOwnProperty('retail')) {
          groups = event.memberGroupLimitMap.retail;
          //get quantities for prices in the limit
          angular.forEach(groups, function(group) {
            var groupQuantity;

            ticketTypeIds = group.groupId.split('-');
            groupQuantity = self.getQuantityForTicketTypes(ticketTypeIds, true);

            angular.forEach(ticketTypeIds, function(ticketTypeId) {
              if (event.ticketLimitGroups[ticketTypeId]) {
                event.ticketLimitGroups[ticketTypeId]['retail'].groups.push({
                  groupMax: group.remaining,
                  groupQuantity: groupQuantity,
                  groupId: group.groupId,
                  isPreventRule: group.isPreventRule,
                  inCartLimit: group.inCartLimit,
                  timeFrame: group.timeFrame,
                  ruleType: group.ruleType
                });
              }
            });

          });
        }

      },

      setMemberTicketLimitGroups: function(event, memberTicketLimitMap, limitMap, isRetail) {
        var key = isRetail ? 'retail' : 'regular',
          prices = event.event && event.event.priceList.prices ? event.event.priceList.prices : [];

        if (prices) {
          angular.forEach(prices, function(ticket) {
            if (!memberTicketLimitMap[ticket.personType.id]) {
              memberTicketLimitMap[ticket.personType.id] = {
                regular: {},
                retail: {}
              };
            }
            if (!memberTicketLimitMap[ticket.personType.id][key]) {
              memberTicketLimitMap[ticket.personType.id][key] = {};
            }

            if (limitMap && limitMap[ticket.personType.id] && limitMap[ticket.personType.id][key] &&
              (limitMap[ticket.personType.id][key].groups instanceof Array)) {
              memberTicketLimitMap[ticket.personType.id][key].groups = limitMap[ticket.personType.id][key].groups;
            } else {
              memberTicketLimitMap[ticket.personType.id][key].groups = [];
            }
          });
        }
      },

      getQuantityForTicketTypes: function(prices, ticketTypeIds, isRetail, sameDayEventTicketQuantities, group) {
        var self = this,
          found = [],
          key,
          quantity = 0;

        if (prices instanceof Array) {

          angular.forEach(ticketTypeIds, function(ticketTypeId) {

            var  r = 0;

            found = prices.filter(function(ticket) {
              var retail = !!ticket.isRetail && true;
              return (ticket.ticketingTypeId === ticketTypeId &&
                (retail === isRetail));
            });

            if (found && found.length) {
              key = found[0].ticketingTypeId;
              key = isRetail ? key + '-retail' : key + '-regular';
              if (sameDayEventTicketQuantities && (sameDayEventTicketQuantities[key] !== undefined)) {
                r = sameDayEventTicketQuantities[key].quantity;
              } else {
                r = found[0].quantity;

                // calculate group quantity for prevents
                if (group && group.isPreventRule) {
                  if (
                    found[0].ticketingTypeId !== group.violation.ticketTypeId &&
                    group.violation.ticketTypeIds.indexOf(found[0].ticketingTypeId) < 0
                  ) {
                    r = 0;
                  }
                }
              }

              r = parseInt(r, 10);

              if (isNaN(r)) {
                r = 0;
              }
            }

            quantity += r;
          });
        }

        return quantity;
      },

      getQuantityForPreventTicketTypes: function(prices, ticketTypeIds, isRetail, sameDayEventTicketQuantities, group) {
        var self = this,
          found = [],
          key,
          quantity = 0;

        if (prices instanceof Array) {

          angular.forEach(ticketTypeIds, function(ticketTypeId) {

            var  r = 0;

            found = prices.filter(function(ticket) {
              var retail = !!ticket.isRetail && true;
              return (ticket.ticketingTypeId === ticketTypeId &&
                (retail === isRetail));
            });

            if (found && found.length) {
              key = found[0].ticketingTypeId;
              key = isRetail ? key + '-retail' : key + '-regular';
              if (sameDayEventTicketQuantities && (sameDayEventTicketQuantities[key] !== undefined)) {
                r = sameDayEventTicketQuantities[key].quantity;
              } else {
                r = found[0].quantity;

                // calculate group quantity for prevented
                if (group && group.isPreventRule) {
                  if (
                    found[0].ticketingTypeId === group.violation.ticketTypeId ||
                    group.violation.ticketTypeIds.indexOf(found[0].ticketingTypeId) >= 0
                  ) {
                    r = 0;
                  }
                }
              }

              r = parseInt(r, 10);

              if (isNaN(r)) {
                r = 0;
              }
            }

            quantity += r;
          });
        }

        return quantity;
      },

      checkLimitExceeded: function(event, ticket, eventId, isRetail, sameDayEventTicketQuantities, onlyForSalesRules) {
        var quantity,
          type = isRetail ? 'retail' : 'regular',
          perTicketLimit = false,
          salesRuleRestriction = false,
          groupLimit = false,
          groupSalesRuleRestriction = false,
          groups = [],
          key = ticket.ticketingTypeId,
          i, ii,
          ticketsQuantity = {},
          isPreventRule = false,
          ticketsCounter = 0,
          ticketTypeIds,
          limit;

        key = isRetail ? key + '-retail' : key + '-regular';

        if (onlyForSalesRules) {
          // it's event sales, so we need to calculate quantities for both retail and regular
          quantity = this.getQuantityForTicketTypes(event.tickets, [ticket.ticketingTypeId], false, sameDayEventTicketQuantities);
          quantity = quantity + this.getQuantityForTicketTypes(event.tickets, [ticket.ticketingTypeId], true, sameDayEventTicketQuantities);
        } else {
          quantity = ticket.quantity;
        }

        if (sameDayEventTicketQuantities && (sameDayEventTicketQuantities[key] !== undefined)) {
          quantity = sameDayEventTicketQuantities[key].quantity;
        }

        if (event.memberTicketLimitMap) {
          perTicketLimit = (event.memberTicketLimitMap[ticket.ticketingTypeId] &&
            event.memberTicketLimitMap[ticket.ticketingTypeId][type] &&
            event.memberTicketLimitMap[ticket.ticketingTypeId][type].remaining !== null &&
            (quantity > event.memberTicketLimitMap[ticket.ticketingTypeId][type].remaining));

          salesRuleRestriction = perTicketLimit && (event.memberTicketLimitMap[ticket.ticketingTypeId][type].ruleType && (event.memberTicketLimitMap[ticket.ticketingTypeId][type].ruleType.name === this.ruleTypes[1].name));

          perTicketLimit = perTicketLimit && (event.memberTicketLimitMap[ticket.ticketingTypeId][type].ruleType && (event.memberTicketLimitMap[ticket.ticketingTypeId][type].ruleType.name === this.ruleTypes[0].name));
        }

        if (event.ticketLimitGroups) {

          if (
            event.ticketLimitGroups[ticket.ticketingTypeId] &&
            event.ticketLimitGroups[ticket.ticketingTypeId][type] &&
            event.ticketLimitGroups[ticket.ticketingTypeId][type].groups instanceof Array
          ) {

            groups = event.ticketLimitGroups[ticket.ticketingTypeId][type].groups;
            ticketsQuantity = this.getTicketsQuantities(event.tickets);

            for (i=0, ii=groups.length; i < ii; i++) {
              ticketsCounter = 0;
              ticketTypeIds = (groups[i].violation.ticketTypeIds.length) ? groups[i].violation.ticketTypeIds : [groups[i].violation.ticketTypeId];

              if (
                groups[i].groupMax !== null &&
                groups[i].groupQuantity !== null
              ) {

                // sales regular limit rule and member rules
                if (
                    !groups[i].isPreventRule &&
                    (groups[i].groupQuantity > groups[i].groupMax)
                ) {
                  groupLimit = true;
                  groupSalesRuleRestriction = groupLimit && (groups[i].ruleType && (groups[i].ruleType.name === this.ruleTypes[1].name));
                  groupLimit = groupLimit && (!groups[i].ruleType || (groups[i].ruleType.name === this.ruleTypes[0].name));

                  if (
                    !onlyForSalesRules && (!groups[i].ruleType || (groups[i].ruleType.name === this.ruleTypes[0].name)) ||
                    onlyForSalesRules && (!groups[i].ruleType || (groups[i].ruleType.name === this.ruleTypes[1].name))
                  ) {
                    break;
                  }
                }

                // sales prevent rule
                if (
                  groups[i].isPreventRule &&
                  (
                    groups[i].violation.ticketTypeId ||
                    groups[i].violation.ticketTypeIds.length
                  ) ||
                  (
                    groups[i].inCartLimit &&
                    ticketsQuantity[groups[i].violation.ticketTypeId] > groups[i].violation.maxLimit
                  ) ||
                  (
                    !groups[i].inCartLimit &&
                    ticketsQuantity[groups[i].violation.ticketTypeId] > groups[i].violation.maxLimit -  groups[i].violation.purchasedQuantity
                  )
                ) {

                  limit = groups[i].groupMax;

                  for (j=0; j < ticketTypeIds.length; j++) {
                    if (ticketsQuantity[ticketTypeIds[j]]) {
                      ticketsCounter += ticketsQuantity[ticketTypeIds[j]];
                    }
                  }

                  for (j=0; j < groups[i].violation.validatedTicketTypeIds.length; j++) {
                    if (
                      (
                        limit < ticketsCounter ||
                        groups[i].violation.maxLimit < groups[i].violation.purchasedQuantity
                      ) &&
                      ticketTypeIds.indexOf(groups[i].violation.validatedTicketTypeIds[j]) < 0 &&
                      ticketsQuantity[groups[i].violation.validatedTicketTypeIds[j]] > 0
                    ) {
                      isPreventRule = true;
                    }
                  }

                  if (isPreventRule) {
                    groupLimit = true;
                    groupSalesRuleRestriction = groupLimit && (groups[i].ruleType && (groups[i].ruleType.name === this.ruleTypes[1].name));
                    groupLimit = groupLimit && (!groups[i].ruleType || (groups[i].ruleType.name === this.ruleTypes[0].name));

                    if (onlyForSalesRules) {
                      break;
                    }
                  }
                }
              }
            }
          }
        }

        event.groupLimitExceeded = groupLimit;
        event.groupSalesRuleRestricted = groupSalesRuleRestriction;
        ticket.limitExceeded = perTicketLimit || groupLimit;
        ticket.salesRuleRestricted = salesRuleRestriction || groupSalesRuleRestriction;

        return onlyForSalesRules ? ticket.salesRuleRestricted : ticket.limitExceeded;
      },

      getTicketsQuantities: function(tickets) {
        r = {},
        ticketId = '';
        for (i=0; i<tickets.length; i++) {
          ticketId = tickets[i].ticketingTypeId || tickets[i].ticketTypeId;
          if (!r.hasOwnProperty(tickets[i].ticketingTypeId)) {
            r[ticketId] = parseInt(tickets[i].quantity, 10);
          } else {
            r[ticketId] += parseInt(tickets[i].quantity, 10);
          }
        }
        return r;
      },

      eventHasLimitErrors: function(event, sameDayEventTicketQuantities, onlyForSalesRules) {
        var r = false,
          limitExceeded,
          salesRulesRestricted,
          prices = event.tickets || [],
          i, ii;

        if (prices instanceof Array) {
          for (i = 0, ii = prices.length; i < ii; i++) {
            limitExceeded = this.checkLimitExceeded(event, prices[i], event.eventId, prices[i].isRetail, sameDayEventTicketQuantities, false);
            salesRulesRestricted = this.checkLimitExceeded(event, prices[i], event.eventId, prices[i].isRetail, sameDayEventTicketQuantities, true);
            if (!r) {
              r = onlyForSalesRules ? salesRulesRestricted : limitExceeded;
            }
          }
        }

        return r;
      },

      arePricePointsEqual: function(src, dest) {
        var r = false;
        if ( (src instanceof Array) && (dest instanceof Array) ){
          r = (src.join('') === dest.join(''));
        }
        return r;
      },

      processSalesRulesLimits: function(limitsData) {
        var i, ii,
          j, jj,
          items,
          eventId,
          allowedQuantity,
          purchasedQuantity,
          inCartLimit,
          pricePointId,
          pricePointIds,
          validatedPricePointIds,
          ruleType,
          isRetail = false,
          timeFrame = null,
          isPreventRule = false;

        this.resetLimits();

        if (limitsData instanceof Array) {

          for (i=0, ii=limitsData.length; i < ii; i++) {
            pricePointIds = [];
            validatedPricePointIds = [];
            pricePointId = null;
            ruleType = this.ruleTypes[0];
            isPreventRule = false;

            items = limitsData[i].items;
            allowedQuantity = limitsData[i].allowedQuantity;
            purchasedQuantity = limitsData[i].purchasedQuantity || 0;
            inCartLimit = (limitsData[i].reason === this.reasonTypes[0].name) || false;
            isRetail = !!limitsData[i].isRetail && true;
            if (limitsData[i].timeFrame) {
              timeFrame = this.findTimeFrame(limitsData[i].timeFrame);
            }

            if (limitsData[i].hasOwnProperty('pricePointIds') && limitsData[i].pricePointIds instanceof Array) {
              if (limitsData[i].pricePointIds.length > 1) {
                pricePointIds = limitsData[i].pricePointIds;
              } else if (limitsData[i].pricePointIds.length === 1){
                pricePointId = limitsData[i].pricePointIds[0];
              }
            } else if (limitsData[i].hasOwnProperty('pricePointId')) {
              pricePointId = limitsData[i].pricePointId;
            }

            if (limitsData[i].hasOwnProperty('validatedPricePointIds') && limitsData[i].validatedPricePointIds instanceof Array) {
              validatedPricePointIds = limitsData[i].validatedPricePointIds;
            }

            eventId = limitsData[i].eventId;

            ruleType = (limitsData[i].ruleType && (limitsData[i].ruleType === this.ruleTypes[1].name)) ? this.ruleTypes[1] : this.ruleTypes[0];
            // if this is an event sales rule and the pricepoints being purchased are the same as the pricepoints that are limited, then this is not a prevent rule
            if (ruleType === this.ruleTypes[1] && !this.arePricePointsEqual((pricePointIds.length ?  pricePointIds : [pricePointId] || []), validatedPricePointIds || [])) {
              isPreventRule = true;
            }

            if ((allowedQuantity !== undefined && allowedQuantity !== null) && eventId) {
              if (!this.limits.hasOwnProperty(eventId)) {
                this.limits[eventId] = {
                  items: []
                };
              }
              this.limits[eventId].items.push( angular.extend({
                maxLimit: allowedQuantity,
                purchasedQuantity: purchasedQuantity,
                ticketTypeId: pricePointId,
                ticketTypeIds: pricePointIds,
                //this is a hack to consolidate prevented ticket types within the same cart
                validatedTicketTypeIds: inCartLimit ? (validatedPricePointIds.concat(pricePointId ? [pricePointId] : pricePointIds)) : validatedPricePointIds,
                isRetail: isRetail,
                timeFrame: timeFrame,
                ruleType: ruleType,
                isPreventRule: isPreventRule,
                inCartLimit: inCartLimit
              }) );
            }
          }

        }
        return this.limits;
      },

      getRemainingLimit: function(eventId, ticketTypeId, isRetail, ruleType) {
        var items,
          i, ii,
          r = null,
          itemIsRetail,
          groupQuantity = 0;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (ruleType === items[i].ruleType) {
                // if is salesrules
                if (items[i].ruleType === this.ruleTypes[1]) {
                  if (
                    (
                      (items[i].validatedTicketTypeIds instanceof Array) &&
                      (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1)
                    ) &&
                    itemIsRetail === isRetail
                  ) {

                    if (items[i].isPreventRule) {
                      r = 0;
                      break;
                    } else {
                      r = (items[i].inCartLimit) ? items[i].maxLimit : items[i].maxLimit - items[i].purchasedQuantity;
                      if (r < 0) {
                        r = 0;
                        break;
                      }
                    }
                  }

                // if is member rule
                } else {
                  if (((items[i].ticketTypeId === ticketTypeId) || (items[i].ticketTypeIds.indexOf(ticketTypeId) > -1)) && itemIsRetail === isRetail) {
                    r = (items[i].inCartLimit) ? items[i].maxLimit : items[i].maxLimit - items[i].purchasedQuantity;
                    if (r < 0) {
                      r = 0;
                      break;
                    }
                  }
                }
              }
            }
          }
        }

        return r;
      },

      getTicketLimit: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              // limit per ticket type
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].isPreventRule ? 0 : items[i].maxLimit;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].maxLimit;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getTicketPurchased: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].purchasedQuantity;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].purchasedQuantity;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getTimeFrame: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].timeFrame;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].timeFrame;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getRuleType: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].ruleType;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].ruleType;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      isPreventRule: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].isPreventRule;
                  break;
                }
              } else {
                r = false;
                break;
              }
            }
          }
        }
        return r;
      },

      isInCartLimit: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].inCartLimit;
                  break;
                }
              } else {
                r = false;
                break;
              }
            }
          }
        }
        return r;
      },

      getViolationForTicketType: function(eventId, ticketTypeId, isRetail) {
        var ruleType = this.getRuleType(eventId, ticketTypeId, isRetail);
        return {
          limit: this.getTicketLimit(eventId, ticketTypeId, isRetail),
          remaining: this.getRemainingLimit(eventId, ticketTypeId, isRetail, ruleType),
          purchased: this.getTicketPurchased(eventId, ticketTypeId, isRetail),
          timeFrame: this.getTimeFrame(eventId, ticketTypeId, isRetail),
          ruleType: this.getRuleType(eventId, ticketTypeId, isRetail),
          isPreventRule: this.isPreventRule(eventId, ticketTypeId, isRetail),
          inCartLimit: this.isInCartLimit(eventId, ticketTypeId, isRetail)
        };
      },

      getGroupViolationsForEvent: function(eventId, isRetail) {
        var items,
          i, ii,
          itemIsRetail,
          groups = [],
          groupIds = [],
          groupQuantity = 0,
          remaining = 0;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              // limit across ticket types
              itemIsRetail = !!items[i].isRetail && true;
              
              remaining = (items[i].inCartLimit) ? items[i].maxLimit : Math.max(items[i].maxLimit - (items[i].purchasedQuantity || 0), 0);

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (
                  (items[i].validatedTicketTypeIds instanceof Array) &&
                  (items[i].validatedTicketTypeIds.length > 1) &&
                  itemIsRetail === isRetail
                ) {
                  groupIds = items[i].validatedTicketTypeIds.slice();

                  if (
                    items[i].ticketTypeId &&
                    groupIds.indexOf(items[i].ticketTypeId) < 0 &&
                    !(
                      items[i].isPreventRule &&
                      items[i].purchasedQuantity > 0
                    )
                  ) {
                    groupIds.push(items[i].ticketTypeId);
                  }

                  groups.push( {
                    limit: items[i].isPreventRule ? 0 : items[i].maxLimit,
                    remaining: remaining,
                    purchased: items[i].purchasedQuantity,
                    groupId: groupIds.join('-'),
                    timeFrame: items[i].timeFrame,
                    ruleType: items[i].ruleType,
                    isPreventRule: items[i].isPreventRule,
                    inCartLimit: items[i].inCartLimit,
                    violation: items[i]
                  } );
                }
              } else {
                if ((items[i].ticketTypeIds instanceof Array) && (items[i].ticketTypeIds.length) &&
                  itemIsRetail === isRetail) {
                  groups.push( {
                    limit: items[i].maxLimit,
                    remaining: remaining,
                    purchased: items[i].purchasedQuantity,
                    groupId: items[i].ticketTypeIds.join('-'),
                    timeFrame: items[i].timeFrame,
                    ruleType: items[i].ruleType,
                    isPreventRule: items[i].isPreventRule,
                    inCartLimit: items[i].inCartLimit,
                    violation: items[i]
                  } );
                }
              }
            }
          }
        }

        return groups.length ? groups : null;
      },

      getGroupViolationsForEventWithNames: function(eventId, tickets, isRetail) {
        var violations = this.getGroupViolationsForEvent(eventId, isRetail),
          self = this;
        if (violations instanceof Array) {
          angular.forEach(violations, function(violation) {
            var ticketTypeIds = violation.groupId ? violation.groupId.split('-') : [],
              names = self.getNamesForTicketTypes(ticketTypeIds, tickets);
            violation.ticketTypes = names.length ? names.join(', ') : '';
          });
        }

        return violations;
      },

      getNamesForTicketTypes: function(ticketTypeIds, tickets) {
        var found = [],
          names = [],
          notRepeated = {};

        if ((tickets instanceof Array) && (ticketTypeIds instanceof Array)) {

          angular.forEach(ticketTypeIds, function(ticketTypeId) {
            notRepeated[ticketTypeId] = ticketTypeId;
          });

          angular.forEach(notRepeated, function(ticketTypeId) {

            found = tickets.filter(function(ticket) {
              return (ticket.ticketTypeId === ticketTypeId);
            });

            if (found && found.length) {
              names.push(found[0].name || found[0].description || '');
            }

          });
        }

        return names;
      },

      getMemberTicketLimit: function(tickets, eventId) {
        var ticketLimitMap = {},
          hasLimits = false,
          hasSalesRuleRestriction = false,
          self = this;

        if (tickets instanceof Array) {

          angular.forEach(tickets, function (ticket) {

            ticketLimitMap[ticket.ticketTypeId] = {
              regular: self.getViolationForTicketType(eventId, ticket.ticketTypeId, false),
              retail: self.getViolationForTicketType(eventId, ticket.ticketTypeId, true)
            };

            if (!hasLimits && ticketLimitMap[ticket.ticketTypeId] &&
              ((ticketLimitMap[ticket.ticketTypeId]['regular'] && (ticketLimitMap[ticket.ticketTypeId]['regular'].limit !== null) && (!ticketLimitMap[ticket.ticketTypeId]['regular'].ruleType || ticketLimitMap[ticket.ticketTypeId]['regular'].ruleType.name === self.ruleTypes[0].name)) || (ticketLimitMap[ticket.ticketTypeId]['retail'] && (ticketLimitMap[ticket.ticketTypeId]['retail'].limit !== null) && (!ticketLimitMap[ticket.ticketTypeId]['retail'].ruleType || ticketLimitMap[ticket.ticketTypeId]['retail'].ruleType.name === self.ruleTypes[0].name))) ) {
              hasLimits = true;
            }

            if (!hasSalesRuleRestriction && ticketLimitMap[ticket.ticketTypeId] &&
              ((ticketLimitMap[ticket.ticketTypeId]['regular'] && (ticketLimitMap[ticket.ticketTypeId]['regular'].limit !== null) && (ticketLimitMap[ticket.ticketTypeId]['regular'].ruleType && ticketLimitMap[ticket.ticketTypeId]['regular'].ruleType.name === self.ruleTypes[1].name)) || (ticketLimitMap[ticket.ticketTypeId]['retail'] && (ticketLimitMap[ticket.ticketTypeId]['retail'].limit !== null) && (ticketLimitMap[ticket.ticketTypeId]['retail'].ruleType && ticketLimitMap[ticket.ticketTypeId]['retail'].ruleType.name === self.ruleTypes[1].name)))) {
              hasSalesRuleRestriction = true;
            }
          });
        }

        return angular.extend(ticketLimitMap, {hasLimits: hasLimits, hasSalesRuleRestriction: hasSalesRuleRestriction});
      },

      getMemberGroupLimit: function(tickets, eventId) {

        var groupLimitMap = {},
            hasRuleType = function(items, ruleType) {
              var filtered = items.filter(function(item) {
                return item.ruleType.name === ruleType;
              });
              return filtered.length > 0;
            };

        if (eventId && (tickets instanceof Array) && tickets.length) {

          groupLimitMap = {
            regular: this.getGroupViolationsForEventWithNames(eventId, tickets, false),
            retail: this.getGroupViolationsForEventWithNames(eventId, tickets, true)
          };

          if ( !groupLimitMap.hasLimits &&
                ((groupLimitMap['regular'] && hasRuleType(groupLimitMap['regular'], this.ruleTypes[0].name)) ||
                  (groupLimitMap['retail'] && hasRuleType(groupLimitMap['retail'], this.ruleTypes[0].name))) ) {
            groupLimitMap.hasLimits = true;
          }

          if ( !groupLimitMap.hasSalesRuleRestriction &&
                ((groupLimitMap['regular'] && hasRuleType(groupLimitMap['regular'], this.ruleTypes[1].name)) ||
                  (groupLimitMap['retail'] && hasRuleType(groupLimitMap['retail'], this.ruleTypes[1].name))) ) {
            groupLimitMap.hasSalesRuleRestriction = true;
          }
        }

        return groupLimitMap;
      },

      getIgnoreTicketLimits: function(event) {
        var tickets = event.tickets || [],
            ignoreLimits = false;

        angular.forEach(tickets, function(ticket) {
          if (ticket.ignoreEntitlements) {
            ignoreLimits = true;
          }
        });

        return ignoreLimits;
      }

    };

}]);